import * as React from "react";
import NoteLogList from "./NoteLogList";
import { MultiLineFullWidthField } from "@poseidon/ui/components/form/MultiLineFullWidthField";
import { FullWidthField } from "@poseidon/ui/components/form/FullWidthField";
import { Field, Formik } from "formik";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import { useAuth } from "@poseidon/ui/components/AuthContext";
import { FormikDisabler } from "@poseidon/ui/components";
import { usePermissions } from "@poseidon/ui/components";
import { Button, Stack } from "@mui/material";

export default function NoteLog({ log, onSubmitHandler }) {
  const { user } = useAuth();
  const { canWrite } = usePermissions();

  return (
    <Stack spacing={3}>
      <NoteLogList log={log} />
      <Formik
        initialValues={{ title: "", body: "" }}
        onSubmit={({ title, body }, actions) =>
          onSubmitHandler({ title, body, user }, actions)
        }
      >
        {({ errors, touched }) => (
          <Form sx={{ textAlign: "right" }}>
            <FormikDisabler disabled={!canWrite} />
            <Stack spacing={3}>
              <Field
                component={FullWidthField}
                name="title"
                label="Title (Optional)"
                margin="none"
                helperText={errors.title}
                error={errors.title && touched.title}
              />
              <Field
                component={MultiLineFullWidthField}
                name="body"
                label="Body"
                margin="none"
                helperText={errors.body}
                error={errors.body && touched.body}
              />
              {canWrite && (
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  margin="normal"
                  sx={{ alignSelf: "start" }}
                >
                  Add new note
                </Button>
              )}
            </Stack>
          </Form>
        )}
      </Formik>
    </Stack>
  );
}
